// extracted by mini-css-extract-plugin
module.exports = {"pageUpSize":"50px"};